module.exports = __webpack_public_path__ + "static/about-bros-c6d228d9079b90b3f073a28b3d65c007.svg";